var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 34 32",
    enableBackground: "new 0 0 34 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.5,1C25.776,1,26,0.776,26,0.5S25.776,0,25.5,0h-17C8.224,0,8,0.224,8,0.5S8.224,1,8.5,1H25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.5,2h-17h-2C3.217,2,1.687,3.166,0.981,4.144c-0.864,1.2-1.026,2.803-0.456,4.514 c0.882,2.646,3.846,5.825,5.668,7.237C6.285,15.966,6.393,16,6.5,16c0.149,0,0.297-0.066,0.396-0.194 c0.169-0.218,0.129-0.532-0.089-0.702c-1.674-1.296-4.525-4.342-5.332-6.763C1.008,6.944,1.121,5.661,1.793,4.729 C2.608,3.598,4.235,3,6.5,3H8v9.5c0,6.726,6.673,10.601,8.036,11.322C16.015,23.878,16,23.937,16,24v2.5c0,0.276,0.224,0.5,0.5,0.5 s0.5-0.224,0.5-0.5V24c0-0.058-0.015-0.112-0.033-0.164C18.481,23.124,26,19.25,26,12.5V3h1.5c2.265,0,3.892,0.598,4.707,1.729 c0.672,0.932,0.785,2.215,0.318,3.613c-0.63,1.891-3.769,5.553-5.332,6.763c-0.218,0.169-0.258,0.483-0.089,0.702 C27.203,15.934,27.351,16,27.5,16c0.107,0,0.215-0.034,0.307-0.104c1.732-1.342,4.961-5.119,5.668-7.237 c0.57-1.711,0.408-3.314-0.456-4.514C32.313,3.166,30.783,2,27.5,2H25.5z M25,12.5c0,6.093-7.152,9.804-8.486,10.443 C15.286,22.278,9,18.576,9,12.5V3h16V12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11,28c-1.141,0-2,0.86-2,2v1.5C9,31.776,9.224,32,9.5,32h14c0.276,0,0.5-0.224,0.5-0.5v-1.425 C24,28.912,23.121,28,22,28H11z M23,30.075V31H10v-1c0-0.589,0.411-1,1-1h11C22.57,29,23,29.462,23,30.075z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboard);
export default __webpack_public_path__ + "static/media/leaderboard.29878c423cb934824d3b3f82fa4cb4b9.svg";
export { ForwardRef as ReactComponent };